import React from 'react';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

export const NavigationButtons = ({
  isValid,
  isLocked,
  isA2HSFeatureEnabled,
  resetLabel,
  a2hsLabel,
  handleReset,
  handleSubmit,
  handleA2HS
}) => (
  <>
    <NavigationButtonGroup
      secondaryButtons={
        <NavigationButton.Secondary
          isLocked={isLocked}
          labelText={resetLabel}
          onClick={handleReset}
        />
      }
      primaryButton={<NavigationButton.Confirm isLocked={isLocked} onClick={handleSubmit} />}
    />
    {isA2HSFeatureEnabled && (
      <NavigationButton.Secondary
        isLocked={isLocked || !isValid}
        labelText={a2hsLabel}
        onClick={handleA2HS}
      />
    )}
  </>
);
